import { useContext, useEffect, useState } from "react";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { AppContext } from "../../../AppProvider";
import { DashboardContext } from "../../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
import ToogleButton from "../../../controls/ToogleButton";
import "../../../../styles/Widgets/LiquidLevel/NewVerticalCylinderTankWidget.css";
import { useParams } from "react-router-dom";
import {v4 as uuidv4} from 'uuid';
import { FindAvailableCoordinates } from "../../../../functions/FindAvailableCoordinates";
import { inactivityThresholds } from "./inactivityThresholds.js";

const NewVerticalCylinderTankWidget = () =>{
    const {user} = useContext(AppContext);
    const {
        selectedNewWidgetWindow,setSelectedNewWidgetWindow,
        activeDashboardState,setActiveDashboardState,
    } = useContext(DashboardContext);
    const {tenantId} = useParams();
    const [showDevicesBrowser,setShowDevicesBrowser] = useState(false);
    const [showDataKeysBrowser,setShowDataKeysBrowser] = useState(false);
    const [selectedDataSourceType,setSelectedDataSourceType] = useState('device');
    const [selectedDataSourceDeviceSummary,setSelectedDataSourceDeviceSummary] = useState(null);
    const [selectedDataSourceDevice,setSelectedDataSourceDevice] = useState(null);
    const [selectedDataSourceDeviceId,setSelectedDataSourceDeviceId] = useState(null);
    const [dataSourceDeviceFilterString,setDataSourceDeviceFilterString] = useState('');
    const [selectedDataSourceDataKey,setSelectedDataSourceDataKey] = useState(null);
    const [dataSourceDataKeyFilterString,setDataSourceDataKeyFilterString] = useState('');
    const [refreshRate,setRefreshRate] = useState('1 second');
    const [tankTitle,setTankTitle] = useState('');
    const [showTitle,setShowTitle] = useState(true);
    const [showInactivityThresholdsBrowser,setShowInactivityThresholdsBrowser] = useState(false);
    const [selectedInactivityThreshold,setSelectedInactivityThreshold] = useState(86400000);
    const [applyInactivityEffects,setApplyInactivityEffects] = useState(false);
    const [titleColor,setTitleColor] = useState('#000000');
    const [tankColor,setTankColor] = useState('#00008B');
    const [tankBackgroundColor,setTankBackgroundColor] = useState('#FFFFFF');
    const [tankHighLevelColor,setTankHighLevelColor] = useState('#0000FF');
    const [tankLowLevelColor,setTankLowLevelColor] = useState('#FF0000');
    const [tankInactiveColor,setTankInactiveColor] = useState('#D3D3D3');
    const [borderRadius,setBorderRadius] = useState(0);
    const [mobileHeightFactor,setMobileHeightFactor] = useState(1);
    const [lowLevelThreshold,setLowLevelThreshold] = useState(0);
    const [maximumValue,setMaximumValue] = useState('');
    const [showUnitsBrowser,setShowUnitsBrowser] = useState(false);
    const [selectedUnits,setSelectedUnits] = useState({name: 'Kilogram',symbol:'Kg'});
    const [unitsFilterString,setUnitsFilterString] = useState('');
    const [displayType,setDisplayType] = useState('actual');
    const [devicesSummary,setDevicesSummary] = useState([]);
    const units = [
        {name: 'Litre',symbol:'L'},
        {name: 'Gram',symbol:'g'},
        {name: 'Kilogram',symbol:'Kg'},
        {name: 'Cubic Meter',symbol:'m³'},
        {name: 'Cubic Millimeter',symbol:'mm³'}
    ];
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices?page=1&&limit=1000`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when retrieving devices summary: ',error);
        }
    };
    const fetchSelectedDataSourceDevice = async() =>{
        try{
            if(!selectedDataSourceDeviceSummary || !selectedDataSourceDeviceSummary.id) return;
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/devices/${selectedDataSourceDeviceSummary?.id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setSelectedDataSourceDevice(responseData);
            }
        }
        catch(error){
            console.error('An error occurred when retrieving the selected device: ',error);
        }
    };
    const hexToRgb = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `rgb(${r}, ${g}, ${b})`;
    };
    const getBrightness = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (0.2126 * r + 0.7152 * g + 0.0722 * b);
    };
    const getNewWidget = () =>{
        const verticalCylinderTankWidget = {
                type: 'vertical_cylinder_tank',
                sizeX: 4,
                sizeY: 4,
                row: 0,
                col: 3,
                borderRadius:borderRadius,
                mobileHeightFactor: mobileHeightFactor,
                config:{
                    dataSource:{
                        deviceId:selectedDataSourceDevice?.id,
                        dataKey:{
                            key:selectedDataSourceDataKey?.key
                        },
                        refreshRate:refreshRate
                    },
                    appearance:{
                        title:tankTitle,
                        showTitle:showTitle,
                        inactivityThreshold:selectedInactivityThreshold,
                        applyInactivityEffects:applyInactivityEffects,
                        titleColor: titleColor,
                        tankColor:tankColor,
                        backgroundColor:tankBackgroundColor,
                        highLevelColor:tankHighLevelColor,
                        lowLevelColor:tankLowLevelColor,
                        inactiveColor:tankInactiveColor
                    },
                    data:{
                        lowLevelThreshold:lowLevelThreshold,
                        maximumValue:!maximumValue || isNaN(Number(String(maximumValue.replaceAll(',',''))))? 0:Number(String(maximumValue.replaceAll(',',''))),
                        units:selectedUnits,
                        displayType:displayType
                    }
                },
                id: uuidv4()
            };
        return verticalCylinderTankWidget;
    };
    const addWidget = () =>{
        if(!Array.isArray(activeDashboardState?.widgets)) return;
        const widget = getNewWidget();
        const {row,col} = FindAvailableCoordinates(activeDashboardState.widgets,widget,20);
        widget.row = row;
        widget.col = col;
        setActiveDashboardState(prev => ({
            ...prev,widgets:[...(prev?.widgets || []),widget]
        }));
        disposeWindow();
    };
    const resetNewVerticalCylinderTankWidgetWindow = () =>{
        setShowDevicesBrowser(false);
        setShowDataKeysBrowser(false);
        setSelectedDataSourceType('device');
        setSelectedDataSourceDeviceSummary(null);
        setSelectedDataSourceDevice(null);
        setSelectedDataSourceDeviceId(null);
        setDataSourceDeviceFilterString('');
        setSelectedDataSourceDataKey(null);
        setDataSourceDataKeyFilterString('');
        setRefreshRate('1 second');
        setTankTitle('');
        setShowTitle(true);
        setTitleColor('#000000');
        setTankColor('#00008B');
        setTankBackgroundColor('#FFFFFF');
        setTankHighLevelColor('#0000FF');
        setTankLowLevelColor('#FF0000');
        setBorderRadius(0);
        setMobileHeightFactor(1);
        setLowLevelThreshold(0);
        setMaximumValue('');
        setShowUnitsBrowser(false);
        setSelectedUnits({name: 'Kilogram',symbol:'Kg'});
        setUnitsFilterString('');
        setDisplayType('actual');
        setDevicesSummary([]);
    };
    const disposeWindow = () =>{
        resetNewVerticalCylinderTankWidgetWindow();
        setSelectedNewWidgetWindow('');
    };
    useEffect(() =>{
        if(selectedNewWidgetWindow === 'vertical_cylinder_tank') fetchDevicesSummary();
    },[selectedNewWidgetWindow]);
    useEffect(() =>{
        if(devicesSummary && devicesSummary.length > 0 && selectedDataSourceDeviceId !== null){
            devicesSummary.forEach(deviceSummary =>{
                if(deviceSummary.id === selectedDataSourceDeviceId){
                    setSelectedDataSourceDeviceSummary(deviceSummary);
                    setSelectedDataSourceDeviceId(null);
                }
            })
        }
    },[devicesSummary]);
    useEffect(() =>{
        if(selectedDataSourceDeviceSummary){
            fetchSelectedDataSourceDevice();
        }
        else setSelectedDataSourceDevice(null);
    },[selectedDataSourceDeviceSummary]);
    useEffect(() =>{
        if(!selectedDataSourceDevice){
            setSelectedDataSourceDataKey(null);
            setDataSourceDataKeyFilterString('');
        }
        else setTankTitle(selectedDataSourceDevice?.name)
    },[selectedDataSourceDevice]);
    if(selectedNewWidgetWindow !== 'vertical_cylinder_tank') return null;
    return(
        <div className="new-vertical-cylinder-tank-widget-parent-container">
            <div className="new-vertical-cylinder-tank-widget-container">
                <div className="new-vertical-cylinder-tank-widget-header-container">
                    <div>
                        <h1>Add widget: Vertical cylinder tank</h1>
                    </div>
                    <div className="buttons-container">
                        <button
                            className="help-button"
                            title="Go to help page">?
                        </button>
                        <button
                            className="close-editor-button"
                            onClick={() => disposeWindow()}>&#10006;
                        </button>
                    </div>
                </div>
                <div className="new-vertical-cylinder-tank-widget-body-container">
                    <div className="new-vertical-cylinder-tank-widget-data-source-container">
                        <div className="data-source-header-container">
                            <h3>Datasource</h3>
                            <div>
                                <button
                                    className={selectedDataSourceType === 'device'? 'active':''}
                                    onClick={() => setSelectedDataSourceType('device')}>Device</button>
                                <button
                                    className={selectedDataSourceType === 'entity-alias'? 'active':''}
                                    onClick={() => setSelectedDataSourceType('entity-alias')}>Entity alias</button>
                            </div>
                        </div>
                        <div className="data-source-body-container">
                            <div className="device-selection-container">
                                <p>Device<span>*</span></p>
                                <div className="entry-container">
                                    <input className={`${selectedDataSourceDevice? 'active':'inactive'}`}
                                        placeholder="Select a device"
                                        value={
                                            selectedDataSourceDevice? selectedDataSourceDevice?.name:dataSourceDeviceFilterString
                                        }
                                        onChange={(e) =>{
                                            setDataSourceDeviceFilterString(e.target.value)
                                        }}
                                        onFocus={() => setShowDevicesBrowser(true)}
                                        onBlur={() => {
                                            setTimeout(() =>{
                                                setShowDevicesBrowser(false);
                                            },200);
                                        }}
                                    />
                                    <p  style={{display:selectedDataSourceDeviceSummary? 'flex':'none'}}
                                        title="Remove selected device"
                                        onClick={() =>{
                                            setDataSourceDeviceFilterString('');
                                            setSelectedDataSourceDeviceSummary(null);
                                        }}>&#10006;
                                    </p>
                                </div>
                                <div className={`devices-browser ${showDevicesBrowser? 'active':'none'}`}>
                                    {devicesSummary && devicesSummary.length > 0 && 
                                    [...devicesSummary].filter(deviceSummary => 
                                        deviceSummary?.name?.toLowerCase().includes(dataSourceDeviceFilterString.toLowerCase())
                                    ).sort((a,b) => a.name.localeCompare(b.name)).map((deviceSummary,index) =>(
                                        <div key={index} onClick={(e) =>{
                                            e.stopPropagation();
                                            setSelectedDataSourceDeviceSummary(deviceSummary);
                                        }}>
                                            <p>{deviceSummary?.name}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={`data-key-selection-container ${selectedDataSourceDevice? '':'inactive'}`}>
                                <p>Data key<span>*</span></p>
                                <input
                                    style={{
                                        display: `${selectedDataSourceDataKey? 'none':'block'}`
                                    }}
                                    placeholder={selectedDataSourceDevice? "Select a data key":"Please select a device first"}
                                    value={dataSourceDataKeyFilterString}
                                    readOnly={!selectedDataSourceDevice}
                                    onChange={(e) =>{
                                        setDataSourceDataKeyFilterString(e.target.value);
                                    }}
                                    onFocus={() => setShowDataKeysBrowser(true)}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowDataKeysBrowser(false);
                                        }, 200);
                                    }}
                                />
                                <button
                                    style={{
                                        display: `${selectedDataSourceDataKey? 'inline-block':'none'}`
                                    }}>
                                    <span className="data-key-icon">&#8623;</span>
                                    <span>{selectedDataSourceDataKey? selectedDataSourceDataKey.key:'Select a data key'}</span>
                                    <span
                                        className="data-key-close-icon"
                                        title="Remove data key"
                                        onClick={() =>{
                                            setDataSourceDataKeyFilterString('');
                                            setSelectedDataSourceDataKey(null)
                                        }}>&#10006;
                                    </span>
                                </button>
                                <div className={`data-keys-browser ${showDataKeysBrowser? 'active':'none'}`}>
                                    {selectedDataSourceDevice && 
                                    selectedDataSourceDevice.latestTelemetry &&
                                    selectedDataSourceDevice.latestTelemetry.filter(dataKey =>
                                        dataKey?.key.toLowerCase().includes(dataSourceDataKeyFilterString.toLocaleLowerCase())
                                    ).sort((a,b) => a.key.localeCompare(b.key)).map((dataKey,index) =>(
                                        <div key={index} onClick={() =>{
                                            setSelectedDataSourceDataKey(dataKey);
                                        }}>
                                        <p onClick={() =>{
                                            setSelectedDataSourceDataKey(dataKey);
                                        }}>{dataKey.key}</p>
                                    </div>))}
                                </div>
                            </div>
                            <div className="refresh-rate-container">
                                <p>Refresh rate<span>*</span></p>
                                <div className="refresh-rate-entry-container">
                                    <input
                                        value={refreshRate}
                                        onChange={(e) =>{
                                            const value = e.target.value;
                                            if(value === '') setRefreshRate('');
                                            else if(/^\d+$/.test(value) && Number(value) >= 1) setRefreshRate(String(Number(value)));
                                        }}
                                        onBlur={() =>{
                                            if(refreshRate.includes(' seconds') || refreshRate.includes(' second')) return;
                                            else if(refreshRate === '' || isNaN(Number(refreshRate))) setRefreshRate('1 second');
                                            else setRefreshRate(`${Number(refreshRate)} second${Number(refreshRate) > 1? 's':''}`);
                                        }}
                                        onFocus={() =>{
                                            if(refreshRate.includes(' seconds')){
                                                const value = refreshRate.replace(' seconds','');
                                                setRefreshRate(value);
                                            }
                                            else if(refreshRate.includes(' second')){
                                                const value = refreshRate.replace(' second','');
                                                setRefreshRate(value);
                                            }
                                        }}
                                    />
                                    <div>
                                        <p className="increment"
                                            onClick={() =>{
                                                let currentRefreshRate = refreshRate;
                                                if(currentRefreshRate.includes(' seconds')) currentRefreshRate = currentRefreshRate.replace(' seconds','');
                                                else if(currentRefreshRate.includes( ' second')) currentRefreshRate = currentRefreshRate.replace(' second','');
                                                let currentNumericalRefreshRate = Number(currentRefreshRate);
                                                setRefreshRate(isNaN(currentNumericalRefreshRate)? '1 second':String(currentNumericalRefreshRate + 1) + ' seconds');
                                            }}>&#9650;</p>
                                        <p className="decrement"
                                            onClick={() =>{
                                                let currentRefreshRate = refreshRate;
                                                if(currentRefreshRate.includes(' seconds')) currentRefreshRate = currentRefreshRate.replace(' seconds','');
                                                else if(currentRefreshRate.includes( ' second')) currentRefreshRate = currentRefreshRate.replace(' second',''); 
                                                let currentNumericalRefreshRate = Number(currentRefreshRate);
                                                setRefreshRate(isNaN(currentNumericalRefreshRate) || currentNumericalRefreshRate <= 1? '1 second':String(currentNumericalRefreshRate - 1) + ` second${currentNumericalRefreshRate > 2? 's':''}`);
                                            }}>&#9660;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="new-vertical-cylinder-tank-widget-appearance-container">
                        <div className="appearance-header-container">
                            <h3>Appearance</h3>
                        </div>
                        <div className="appearance-body-container">
                            <div className="title-container">
                                <div className="title-entry-container">
                                    <p>Title</p>
                                    <input
                                        value={tankTitle}
                                        onChange={(e) =>{
                                            setTankTitle(e.target.value)
                                        }}
                                    />
                                </div>
                                <div className="show-title-container">
                                    <p>Show title</p>
                                    <ToogleButton
                                        size="50px"
                                        marginLeft="20px"
                                        isToogled={showTitle}
                                        onChange={() => setShowTitle(!showTitle)}
                                    />
                                </div>
                            </div>
                            <div className="inactivity-effects-container">
                                <div className="inactivity-effects-selection-container">
                                    <p>Inactivity threshold</p>
                                    <input
                                        readOnly
                                        value={inactivityThresholds.find(inactivityThreshold => inactivityThreshold?.value === selectedInactivityThreshold)?.label || ''}
                                        onFocus={() => setShowInactivityThresholdsBrowser(true)}
                                        onBlur={() => {
                                            setTimeout(() => {setShowInactivityThresholdsBrowser(false)},100);
                                        }}
                                    />
                                    <div className={`inactivity-threshold-browser ${showInactivityThresholdsBrowser? 'active':''}`}>
                                        {inactivityThresholds?.map((inactivityThreshold) =>(
                                            <div key={inactivityThreshold?.value} onClick={() => setSelectedInactivityThreshold(inactivityThreshold?.value)}>
                                                <p>{inactivityThreshold?.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="apply-inactivity-effects-container">
                                    <p>Apply effects</p>
                                    <ToogleButton
                                        size="50px"
                                        marginLeft="20px"
                                        isToogled={applyInactivityEffects}
                                        onChange={() => setApplyInactivityEffects(!applyInactivityEffects)}
                                    />
                                </div>
                            </div>
                            <div className="title-color-container">
                                <p>Title color</p>
                                <div>
                                    <p style={{
                                        color:titleColor,
                                        textShadow: getBrightness(titleColor) > 180? '1px 1px 1px rgba(0,0,0,1)':'none'
                                    }}>{hexToRgb(titleColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={titleColor}
                                        onChange={(e) => setTitleColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="tank-color-container">
                                <p>Tank color</p>
                                <div>
                                    <p style={{
                                        color:tankColor,
                                        textShadow: getBrightness(tankColor) > 180 ? '1px 1px 1px rgba(0,0,0,1)' : 'none'
                                    }}>{hexToRgb(tankColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={tankColor}
                                        onChange={(e) => setTankColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="tank-background-color-container">
                                <p>Tank background color</p>
                                <div>
                                    <p style={{
                                        color:tankBackgroundColor,
                                        textShadow: getBrightness(tankBackgroundColor) > 180 ? '1px 1px 1px rgba(0,0,0,1)' : 'none'
                                    }}>{hexToRgb(tankBackgroundColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={tankBackgroundColor}
                                        onChange={(e) => setTankBackgroundColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="tank-high-level-color-container">
                                <p>High level color</p>
                                <div>
                                    <p style={{
                                        color:tankHighLevelColor,
                                        textShadow: getBrightness(tankHighLevelColor) > 180 ? '1px 1px 1px rgba(0,0,0,1)' : 'none'
                                    }}>{hexToRgb(tankHighLevelColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={tankHighLevelColor}
                                        onChange={(e) => setTankHighLevelColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="tank-low-level-color-container">
                                <p>Low level color</p>
                                <div>
                                    <p style={{
                                        color:tankLowLevelColor,
                                        textShadow: getBrightness(tankLowLevelColor) > 180 ? '1px 1px 1px rgba(0,0,0,1)' : 'none'
                                    }}>{hexToRgb(tankLowLevelColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={tankLowLevelColor}
                                        onChange={(e) => setTankLowLevelColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="tank-inactive-color-container">
                                <p>Inactive color</p>
                                <div>
                                    <p style={{
                                        color:tankInactiveColor,
                                        textShadow: getBrightness(tankInactiveColor) > 180 ? '1px 1px 1px rgba(0,0,0,1)' : 'none'
                                    }}>{hexToRgb(tankInactiveColor)}</p>
                                    <input
                                        type="color"
                                        title="Select color"
                                        value={tankInactiveColor}
                                        onChange={(e) => setTankInactiveColor(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="border-radius-container">
                                <p>Border radius</p>
                                <div>
                                    <p>{borderRadius}%</p>
                                    <input
                                        type="range"
                                        min={0}
                                        max={100}
                                        step={1}
                                        value={borderRadius}
                                        onChange={(e) => setBorderRadius(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                            <div className="mobile-height-container">
                                <p>Mobile height factor</p>
                                <div>
                                    <p>{mobileHeightFactor}</p>
                                    <input
                                        type="range"
                                        min={1}
                                        max={10}
                                        step={0.1}
                                        value={mobileHeightFactor}
                                        onChange={(e) => setMobileHeightFactor(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="new-vertical-cylinder-tank-widget-data-container">
                        <div className="data-header-container">
                            <h3>Data</h3>
                        </div>
                        <div className="low-level-threshold-container">
                            <p>Low level threshold</p>
                            <div>
                                <p>{lowLevelThreshold}%</p>
                                <input
                                    type="range"
                                    min={0}
                                    max={100}
                                    step={1}
                                    value={lowLevelThreshold}
                                    onChange={(e) => setLowLevelThreshold(Number(e.target.value))}
                                />
                            </div>
                        </div>
                        <div className="maximum-value-container">
                            <p>Maximum value<span>*</span></p>
                            <input
                                placeholder="Enter the maximum value for the tank"
                                value={maximumValue}
                                onChange={(e) =>{
                                    const value = e.target.value;
                                    if(/^\d*\.?\d*$/.test(value)) setMaximumValue(value);
                                }}
                                onFocus={(e) =>{
                                    setMaximumValue(maximumValue? String(maximumValue).replaceAll(',',''):'');
                                }}
                                onBlur={(e) =>{
                                    if(maximumValue === '') return;
                                    else if(!isNaN(Number(maximumValue))) setMaximumValue(Number(maximumValue).toLocaleString('en-US',{
                                        minimumFractionDigits:0,
                                        maximumFractionDigits:4
                                    }))
                                }}
                            />
                        </div>
                        <div className="units-container">
                            <p>Units<span>*</span></p>
                            <div className="entry-container">
                                <input className={selectedUnits? 'active':'inactive'}
                                    title={selectedUnits || unitsFilterString.length === 0? "":"Invalid entry. Select a unit from the available options"}
                                    placeholder="Select a unit"
                                    value={selectedUnits? `${selectedUnits.name} (${selectedUnits.symbol})`:unitsFilterString}
                                    onChange={(e) => setUnitsFilterString(e.target.value)}
                                    onFocus={() => setShowUnitsBrowser(true)}
                                    onBlur={() =>{
                                        setTimeout(() =>{
                                            setShowUnitsBrowser(false);
                                        },200);
                                    }}
                                />
                                <p onClick={() =>{
                                    setUnitsFilterString('');
                                    setSelectedUnits(null);
                                }}>&#10006;</p>
                            </div>
                            <div className={`units-browser-container ${showUnitsBrowser? 'active':''}`}>
                                {units.filter(unit => 
                                    unit.name.toLocaleLowerCase().includes(unitsFilterString.toLocaleLowerCase())
                                ).map((unit,index) =>(
                                    <div key={index} onClick={(e) =>{
                                        e.stopPropagation();
                                        setSelectedUnits(unit);
                                    }}>
                                        <p>{unit.name}<span>{unit.symbol}</span></p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="display-container">
                            <p>Display<span>*</span></p>
                            <select
                                value={displayType}
                                onChange={(e) => setDisplayType(e.target.value)}>
                                <option value={'actual'}>Actual value</option>
                                <option value={'percentage'}>Percentage</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="new-vertical-cylinder-tank-control-buttons-container">
                    <button className="cancel-button" onClick={() => disposeWindow()}>
                        Cancel
                    </button>
                    <button className="add-button" onClick={() =>addWidget()}>Add
                    </button>
                </div>
            </div>
        </div>
    );
};
export default NewVerticalCylinderTankWidget;